import { Box, Center } from '@mantine/core';

import classes from './index.module.css';
import { ReactNode } from 'react';

interface IHeroBackground {
  background?: boolean;
  image?: any;
  children?: ReactNode;
}

const HeroBackground = ({
  image,
  background,
  children
}: IHeroBackground) => {
  let content = (
    <Box pos="relative" className={classes.wrapper}>
      <img 
        src={image} 
        alt="Hero" 
        height="100%" 
        width="100%" 
        fetchPriority="high" 
        loading="eager"
        decoding="async" 
        className={classes.image}
      />
      <Center className={classes.content}>{children}</Center>
    </Box>
  )

  if (background) {
    content = (
      <Box className={classes.background}>
        <Center className={classes.content}>{children}</Center>
      </Box>
    )
  }

  return content;
}

export default HeroBackground;